module.exports = __webpack_public_path__ + "img/nocar2.e6976623.png";